// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"970ddf01","353":"9cb02f05"}[chunkId] + ".chunk.css";
};